import styled from 'styled-components';

export const DetailsCardContainer = styled.div`
  gap: 8px;
  display: grid;
  grid-template-columns: 1fr 1fr;
`;
